import { render, staticRenderFns } from "./VendaProduto.vue?vue&type=template&id=495d2851&scoped=true"
import script from "./VendaProduto.vue?vue&type=script&lang=js"
export * from "./VendaProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d2851",
  null
  
)

export default component.exports